import React from 'react'
import styled from 'styled-components'

import { LiveApi } from 'live/lib/api'

const ConfigContainer = styled.div`
    padding-top: 100px;
    text-align: center;
    font-size: 16px;
`

const Config = () => (
    <ConfigContainer>
        To configure the alarms go to the Alarms tab on the <a href="/#/wells/">Wellbores page</a>
    </ConfigContainer>
)

LiveApi.Extension.configuration.entries.register(
    {
        component: Config,
        name: 'Alarms Configuration',
        group: 'alarms',
        area: 'alarm'
    },
    'system'
)
